import api from '../callApi';
import humanparser from 'humanparser';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const completePetition = (apiRequestData, actionCompletedTime, values, actionType) => {
    const name = values.fullName && humanparser.parseName(values.fullName);
    let address = {
        streetNo: values.address && parseAddressNumber(values.address),
        street: values.address && parseAddressStreet(values.address),
        state: values.stateId,
        city: values.homeCity,
        country: values.country,
        zipCode: values.postalCode,
        source: 0 // is user input
    };

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,
        email: values.email,
        from: values.petition,
        prefix: values.prefix,
        text: values.message,
        notifyResult: values.getUpdates,
        partnerOptIn: values.partnerOptIn,
        phoneNumber: values.phone,
        zipCode: values.postalCode,
        address: address
    };

    if (name){
        request.firstName = name.middleName ? name.firstName + ' ' + name.middleName : name.firstName;
        request.lastName = name.lastName;
    }

    const endpoint = actionType === 'petition' ? 'Widget/CompletePetitionAsync' : 'Widget/CompleteOpinionAsync';

    return api
        .post(endpoint, request, { useFingerprint: true })
        .then(response => {
            return response;
        });
};

export default completePetition;
